var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-item"},[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.item.label))]),(_vm.item.link)?_c('a',{staticClass:"title",attrs:{"href":_vm.item.link},domProps:{"innerHTML":_vm._s(_vm.label)}}):_c('p',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }